const MenuMobile = {
  root: null,
  panel: null,
  openButton: null,

  open: function () {
    const { root } = MenuMobile;
    if (!root) return;

    root.hidden = false;
    // Um frame pra a transição de entrada rodar.
    requestAnimationFrame(() => {
      root.classList.add('is-open');
      document.body.classList.add('rd-drawer-open');
    });

    if (MenuMobile.openButton) {
      MenuMobile.openButton.setAttribute('aria-expanded', 'true');
    }
  },

  close: function () {
    const { root, panel } = MenuMobile;
    if (!root || !root.classList.contains('is-open')) return;

    root.classList.remove('is-open');
    document.body.classList.remove('rd-drawer-open');

    if (MenuMobile.openButton) {
      MenuMobile.openButton.setAttribute('aria-expanded', 'false');
    }

    // Fecha accordion aberto ao sair.
    root.querySelectorAll('[data-rd-drawer-item].is-open').forEach(item => {
      MenuMobile.closeItem(item);
    });

    // Volta o "Buscar" ao estado de texto se o campo estava aberto.
    if (window.rdSearch && typeof window.rdSearch.closeMobile === 'function') {
      window.rdSearch.closeMobile();
    }
    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      root.hidden = true;
      panel.removeEventListener('transitionend', onEnd);
    };

    const onEnd = (event) => {
      if (event.target !== panel || event.propertyName !== 'transform') return;
      finish();
    };

    panel.addEventListener('transitionend', onEnd);
    // Fallback caso o transitionend não dispare.
    setTimeout(finish, 320);
  },

  closeItem: function (item) {
    const toggle = item.querySelector('[data-rd-drawer-toggle]');
    const sub = item.querySelector('[data-rd-drawer-sub]');
    item.classList.remove('is-open');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      const label = toggle.getAttribute('aria-label') || '';
      if (label.indexOf('Fechar submenu') === 0) {
        toggle.setAttribute('aria-label', label.replace('Fechar submenu', 'Abrir submenu'));
      }
    }
    if (sub) sub.hidden = true;
  },

  openItem: function (item) {
    // Um accordion aberto por vez.
    MenuMobile.root.querySelectorAll('[data-rd-drawer-item].is-open').forEach(other => {
      if (other !== item) MenuMobile.closeItem(other);
    });

    const toggle = item.querySelector('[data-rd-drawer-toggle]');
    const sub = item.querySelector('[data-rd-drawer-sub]');
    item.classList.add('is-open');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'true');
      const label = toggle.getAttribute('aria-label') || '';
      if (label.indexOf('Abrir submenu') === 0) {
        toggle.setAttribute('aria-label', label.replace('Abrir submenu', 'Fechar submenu'));
      }
    }
    if (sub) sub.hidden = false;
  },

  bind: function () {
    const { root } = MenuMobile;

    MenuMobile.openButton = document.querySelector('[data-rd-drawer-open], [data-action="open-menu-mobile"]');
    if (MenuMobile.openButton) {
      MenuMobile.openButton.setAttribute('aria-expanded', 'false');
      MenuMobile.openButton.setAttribute('aria-controls', 'rd-drawer');
      MenuMobile.openButton.addEventListener('click', (event) => {
        event.preventDefault();
        MenuMobile.open();
      });
    }

    root.querySelectorAll('[data-rd-drawer-close]').forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        MenuMobile.close();
      });
    });

    root.querySelectorAll('[data-rd-drawer-toggle]').forEach(toggle => {
      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        const item = toggle.closest('[data-rd-drawer-item]');
        if (!item) return;

        if (item.classList.contains('is-open')) {
          MenuMobile.closeItem(item);
        } else {
          MenuMobile.openItem(item);
        }
      });
    });

    // Carrinho: fecha o drawer e deixa o CartDrawer abrir.
    const cartButton = root.querySelector('[data-toggle-cart]');
    if (cartButton) {
      cartButton.addEventListener('click', () => {
        MenuMobile.close();
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !root.classList.contains('is-open')) return;

      // 1º Escape cancela a busca inline; 2º fecha o drawer.
      if (window.rdSearch && window.rdSearch.isMobileOpen && window.rdSearch.isMobileOpen()) {
        window.rdSearch.closeMobile();
        return;
      }

      MenuMobile.close();
    });  },

  init: function () {
    MenuMobile.root = document.querySelector('[data-rd-drawer]');
    if (!MenuMobile.root) return;

    MenuMobile.panel = MenuMobile.root.querySelector('[data-rd-drawer-panel]');
    MenuMobile.root.id = 'rd-drawer';
    MenuMobile.bind();

    // Compatível com cartDrawer.js (fecha o menu antes de abrir o carrinho).
    window.mmenu = { close: MenuMobile.close, open: MenuMobile.open };
  },
};

export default MenuMobile;
